import React, { useState } from 'react';

const WebExploitationChallenge = ({ challenge, user }) => {
  const [userSolution, setUserSolution] = useState('');  // Track the user's input
  const [isCorrect, setIsCorrect] = useState(false);  // Track if the solution is correct
  const [hasSubmitted, setHasSubmitted] = useState(false);  // Track if the user has submitted
  const [errorMessage, setErrorMessage] = useState('');  // To display error messages

  // Function to handle the flag submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setHasSubmitted(true);  // Mark that the form has been submitted

    // Check if the user is logged in
    if (!user || !user.username) {
      setErrorMessage('You must be logged in to submit a flag.');
      return;
    }

    // Check if the solution matches the correct flag
    if (userSolution.trim() === challenge.solution) {
      setIsCorrect(true);  // Correct flag

      // Call API to update points and solved challenges
      try {
        const response = await fetch('/api/solve-challenge', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            username: user.username,  // Add the username
            challengeId: challenge.id,  // Add the challenge ID
            pointsEarned: challenge.points,  // Add points for the challenge
          }),
        });

        if (!response.ok) {
          throw new Error('Failed to update points.');
        }

        console.log('Challenge solved and points updated.');
      } catch (error) {
        console.error('Error:', error);
      }
    } else {
      setIsCorrect(false);  // Incorrect flag
    }
  };

  return (
    <div>
      <p className="text-textWhite mb-4">{challenge.description}</p>

      {/* Display an error message if the user is not logged in */}
      {errorMessage && <p className="text-red-500 mb-4">{errorMessage}</p>}

      {/* Embedded webpage */}
      <iframe
        src={challenge.resource}
        className="w-full h-[600px] border border-cyberBlue rounded-lg"
        title={challenge.name}
      ></iframe>

      {/* Flag submission form */}
      <form onSubmit={handleSubmit} className="mt-4">
        <div className="flex items-center">
          <input
            type="text"
            value={userSolution}
            onChange={(e) => setUserSolution(e.target.value)}
            className="bg-gray-800 text-white p-2 rounded-lg flex-grow"
            placeholder="Enter the flag"
          />
          <button type="submit" className="bg-cyberBlue text-black p-2 rounded-lg ml-2">
            Submit Flag
          </button>
        </div>
      </form>

      {/* Show feedback after submission */}
      {hasSubmitted && (
        <p className={`mt-2 ${isCorrect ? 'text-green-500' : 'text-red-500'}`}>
          {isCorrect ? 'Correct! You have found the flag.' : 'Incorrect. Try again.'}
        </p>
      )}
    </div>
  );
};

export default WebExploitationChallenge;
